import { render, staticRenderFns } from "./OnBoard.vue?vue&type=template&id=65abd8ea&scoped=true&"
import script from "./OnBoard.vue?vue&type=script&lang=js&"
export * from "./OnBoard.vue?vue&type=script&lang=js&"
import style0 from "./OnBoard.vue?vue&type=style&index=0&id=65abd8ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65abd8ea",
  null
  
)

export default component.exports